type Method = 'info' | 'warn' | 'error';

const logFunction = (method: Method) => (message: string) => (details?: unknown, additional?: unknown) => {
	const label = details instanceof Error ? details.message : undefined;
	console[method](`${message} ${label ? `: ${label}` : ''}`);

	if (!details) {
		return;
	}

	console.groupCollapsed(label);
	console[method](JSON.stringify({details, additional}, null, 2));
	console.groupEnd();
};

export const logInfo = logFunction('info');
export const logWarn = logFunction('warn');
export const logError = logFunction('error');
